// @flow
import * as React from 'react';
import PropTypes from 'prop-types';

import {makeStyles, Chip} from '@material-ui/core';
import CustomButton from '../../../elements/CustomButton/CustomButton';
import {ArrowForwardIos} from '@material-ui/icons';
import {colors} from '../../../assets/styles/colors';
import {Link} from 'react-router-dom';

type Props = {|
  label?: React.Node,
  secondLine?: string,
  enabled?: boolean, // startIcon
  disabled?: boolean, // prevent click
  path?: string, // path to send
  children?: React.Node, // children
  onClick?: () => void,
  id?: string,
  img: string | null,
|};

export const useStyles = (props: any) =>
  makeStyles(theme => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(0, 3),
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(0, 2),
      },
    },
    logisticsButton: {
      width: '100%',
      margin: theme.spacing(0, -3),
      borderRadius: '0px',
      padding: theme.spacing(3),
      textAlign: 'left',
      justifyContent: 'flex-start',
      maxHeight: 76,
      backgroundColor: 'white',
    },
    label: {
      fontWeight: 500,
      fontSize: '1rem',
      whiteSpace: 'break-spaces',
      color: colors.grey800,
      '&.disabled': {
        color: colors.grey500,
      },
    },
    secondLine: {
      whiteSpace: 'normal',
      color: colors.grey800,
      fontSize: '0.75rem',
      '&.disabled': {
        color: colors.grey500,
      },
    },
    startIcon: {
      marginRight: theme.spacing(2),
    },
    endIcon: {
      marginLeft: 'auto',
      color: colors.grey800,
    },
    divider: {
      background: colors.grey200,
    },
    subRouteHeader: {
      display: 'flex',
      alignItems: 'center',
      margin: theme.spacing(2, 0),
    },
    subRouteTitle: {
      marginLeft: theme.spacing(1),
      fontSize: '1rem',
      fontWeight: 600,
    },
    wrap: {
      display: 'flex',
      alignItems: 'center',
    },
    img: {
      marginRight: theme.spacing(1.5),
      width: 48,
      filter: props.disabled ? 'grayscale(1)' : '',
      height: 48,
      maxWidth: 48,
      maxHeight: 48,
      '& img': {
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: '100%',
        objectFit: 'cover',
      },
    },
    containerTagArrow: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
    },
    chipCustomActivate: {
      backgroundColor: '#10b981',
      color: '#fff',
    },
    chipCustomDeactivate: {
      backgroundColor: 'transparent',
      border: '1px solid #9c9daf',
      color: '#9c9daf',
    },
  }));

export default function ConfigureTagButton(props: Props) {
  const {
    label,
    secondLine,
    enabled,
    disabled,
    path,
    children,
    onClick,
    id,
    img,
  } = props;

  const classes = useStyles({disabled})();

  return (
    <CustomButton
      classes={{
        root: classes.logisticsButton,
        startIcon: classes.startIcon,
        endIcon: classes.endIcon,
      }}
      color="default"
      endIcon={
        path && !disabled ? (
          <div className={classes.containerTagArrow}>
            <Chip
              label={enabled ? 'Activo' : 'Inactivo'}
              className={
                enabled
                  ? classes.chipCustomActivate
                  : classes.chipCustomDeactivate
              }
            />
            <ArrowForwardIos
              style={{
                fontSize: '1rem',
                color: disabled ? colors.grey300 : undefined,
              }}
            />
          </div>
        ) : null
      }
      disabled={disabled}
      onClick={onClick}
      {...(path ? {component: Link, to: path} : {})}
    >
      <div className={classes.wrap}>
        {img && (
          <div className={classes.img}>
            <img src={img} alt="pm" />
          </div>
        )}

        <div>
          <div
            className={`${classes.label} ${disabled ? 'disabled' : ''}`}
            id={id}
          >
            {label || children}
          </div>
          {secondLine && (
            <div
              className={`${classes.secondLine} ${disabled ? 'disabled' : ''}`}
            >
              {secondLine}
            </div>
          )}
        </div>
      </div>
    </CustomButton>
  );
}

ConfigureTagButton.propTypes = {
  label: PropTypes.node,
  secondLine: PropTypes.string,
  enabled: PropTypes.bool,
  disabled: PropTypes.bool,
  path: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  id: PropTypes.string,
  img: PropTypes.string,
};
